import React from 'react';
import { string } from 'prop-types';
import { useIntl } from 'react-intl';
import './specificationSection.scss';

const SpecificationSection = ({ specifications = '' }) => {
    const intl = useIntl();
    const specificationBody =
        specifications
            ?.match(/<li>.*?<\/li>/g)
            ?.slice(0, 3)
            ?.join('') || '';

    return specificationBody ? (
        <div className="producttile__specification">
            <p className="specification__header">{intl.formatMessage({ id: 'product-tile-specifications' })}</p>
            <div
                className="specification__body"
                dangerouslySetInnerHTML={{ __html: `<ul>${specificationBody}</ul>` }}
            />
        </div>
    ) : null;
};

export default React.memo(SpecificationSection);

SpecificationSection.propTypes = {
    specifications: string
};